import { z } from 'zod'
import type { Tool } from '../types.js'

export interface SearchHit {
  id: string
  type: string
  name?: string
  snippet?: string
  score?: number
}

export interface SearchEntitiesDeps {
  search: (input: { query: string; scope: 'all' | 'children' | 'siblings'; userId: string; parentEntityId: string }) => Promise<SearchHit[]>
}

const searchEntitiesSchema = z.object({
  query: z.string().min(1).describe('Natural language search query.'),
  scope: z.enum(['all', 'children', 'siblings']).default('all').describe('Where to search relative to the current entity.'),
})

export const createSearchEntitiesTool = (
  deps: SearchEntitiesDeps
): Tool<z.infer<typeof searchEntitiesSchema>, SearchHit[]> => ({
  name: 'search_entities',
  description:
    "Search the user's entities for content relevant to the query. Prefer this over asking the user for references to their own material.",
  schema: searchEntitiesSchema,
  handler: async (args, ctx) => {
    const hits = await deps.search({
      query: args.query,
      scope: args.scope,
      userId: ctx.userId,
      parentEntityId: ctx.parentEntityId,
    })
    return { ok: true, result: hits }
  },
})
